import { Button, Result, Space } from 'antd'
import { useNavigate, useRouter } from '@tanstack/react-router'
import { HOME_PATH } from '@/router/guards'
import styles from './CenteredResult.module.css'

// 404 页（旧 views/common/NotFoundView.vue）
export function NotFoundPage() {
  const navigate = useNavigate()
  const router = useRouter()

  return (
    <div className={styles.page}>
      <Result
        status="404"
        title="页面不存在"
        subTitle="抱歉，您访问的页面不存在或已被移除。"
        extra={
          <Space>
            <Button type="primary" onClick={() => navigate({ to: HOME_PATH })}>
              返回首页
            </Button>
            <Button onClick={() => router.history.back()}>返回上页</Button>
          </Space>
        }
      />
    </div>
  )
}
